// extracted by mini-css-extract-plugin
export var button = "_6-0";
export var buttonContent = "_6-e";
export var buttonGroup = "_6-c";
export var dontRestrainIconWidth = "_6-a";
export var dropdownButton = "_6-b";
export var iconContainer = "_6-9";
export var lg = "_6-4";
export var md = "_6-3";
export var pending = "_6-f";
export var sm = "_6-2";
export var spinner = "_6-d";
export var squared = "_6-8";
export var wrapText = "_6-g";
export var xl = "_6-5";
export var xs = "_6-1";
export var xxl = "_6-6";
export var xxxl = "_6-7";